<template>
    <div id="app">
        <Header />
        <router-view/>
    </div>
</template>

<script>
export default {
	components: {
		Header: () => import('@/components/Header.vue'),
	}
}
</script>

<style lang="scss">
// @mixin mobile() {
//     @media (max-width: 590px) { @content; }
// }

// @mixin desktop() {
//     @media (min-width: 590px) { @content; }
// }

// * {
//     box-sizing: border-box;
//     word-break: break-word;
//     word-wrap: break-word;
// 	margin: 0;
//     padding: 0;
// }

// html, body {
// 	margin: 0;
//     padding: 0;
//     height: 100%;
//     width: 100%;
//     overflow: hidden;
//     color: #2c3e50;
//     font-size: 12px;
//     font-family: 'Lato', sans-serif;

//     @include mobile {
//         min-width: 300px;
//         width: 100%;               
//     }
// }

// a {
//     text-decoration: none;
// }


#app {
	height: 100%;
	width: 100%;
	overflow: auto;
    background-color: #291E39;
}


</style>
